import { CUSTOM_TEMPLATE_TYPES } from "../CreateCustomTemplateModal/constants/CreateCustomTemplateModal.constants";

export const TEMPLATE_TYPE_LABEL = {
  [CUSTOM_TEMPLATE_TYPES.PROMOTIONAL]: "Promotional Template",
  [CUSTOM_TEMPLATE_TYPES.PRESET_NOTIFICATION]: "Preset Notification Template",
};
